
import { Component, Vue, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import UploadImg from '@/components/upload-img.vue';
import { imgHost, host } from "@/utils/config";
import {
    bAppMallInit,
    bAppMallSave
} from '@/api/toBApi';

import chooseLink from './chooseLink.vue';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        UploadImg,
        'slz-dialog': Dialog,
        'choose-link': chooseLink
    }
})
export default class HomePagePlacement extends Vue {

    private imgUrl = imgHost;
    private uploadApi = host + '/api/image/upload?PlatForm=routuan&Path=image';

    private visible = false;
    private selectedIndex = 0;
    private selectedData = {};

    private loading = false;

    private formData = {
        ImageAdvertisementList: [],// (Array[BAppImageAdvertisementListResponse], optional): 图片广告列表,
        PlatformRankingImgUrl: '',// (string, optional): 平台榜单图片地址,
        PlatformRankingImgWidth: 0,// (int): 平台榜单图片宽度,
        PlatformRankingImgHeight: 0,// (int): 平台榜单图片高度,
        ProductRecommendImgUrl: '',// (string, optional): 商品推荐图片地址,
        ProductRecommendImgWidth: 0,// (int): 商品推荐图片宽度,
        ProductRecommendImgHeight: 0,// (int): 商品推荐图片高度
        ProductPreviewEntranceImgUrl: ''
    }

    @Watch('formData.PlatformRankingImgUrl')
    private PlatformRankingImgUrlChange() {
        let url = this.formData.PlatformRankingImgUrl;
        if (!url) {
            this.formData.PlatformRankingImgWidth = 0;
            this.formData.PlatformRankingImgHeight = 0;
        } else {
            let image = new Image();
            image.onload = () => {
                this.formData.PlatformRankingImgWidth = image.width;
                this.formData.PlatformRankingImgHeight = image.height;
            }
            image.src = this.imgUrl + url;
        }
    }
    @Watch('formData.ProductRecommendImgUrl')
    private ProductRecommendImgUrlChange() {
        let url = this.formData.ProductRecommendImgUrl;
        if (!url) {
            this.formData.ProductRecommendImgWidth = 0;
            this.formData.ProductRecommendImgHeight = 0;
        } else {
            let image = new Image();
            image.onload = () => {
                this.formData.ProductRecommendImgWidth = image.width;
                this.formData.ProductRecommendImgHeight = image.height;
            }
            image.src = this.imgUrl + url;
        }
    }

    private mounted() {
        this.getData();
    }

    private async getData() {
        this.loading = true;
        try {
            const res: any = await bAppMallInit({});

            const {
                PlatformRankingImgUrl,
                ProductRecommendImgUrl
            } = res.Result;

            if (!PlatformRankingImgUrl) {
                res.Result.PlatformRankingImgUrl = '/image/20250630-694eee5c-85f1-4f0a-a2b9-aedf8603e00e.png';
            }
            if (!ProductRecommendImgUrl) {
                res.Result.ProductRecommendImgUrl = '/image/20250630-694eee5c-85f1-4f0a-a2b9-aedf8603e00e.png';
            }

            this.formData = res.Result;


        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

    private uploadSucess(list: any, key: string) {
        this.formData[key] = list[0]
    }
    private showToast() {
        this.$message.error('最多上传10张图片')
    }
    private handleAddItem() {
        this.formData.ImageAdvertisementList.push({
            Id: '',
            ImgUrl: '',
            LinkResourceType: '',
            LinkInfoJson: '',
            ImgWidth: '',
            ImgHeight: '',
            LinkResourceId: ''
        })
    }
    private getPageInfo(item) {
        try {
            let obj = JSON.parse(item.LinkInfoJson);
            return obj || {};
        } catch (error) {
            return {}
        }
    }
    private beforeUpload(file) {

        let types = ['image/png', 'image/jpg', 'image/jpeg'];
        if (!types.includes(file.type.toLowerCase())) {
            return false;
        }

        const isLimit2M = file.size / 1024 / 1024 > 2;
        if (isLimit2M) {
            this.$message.error('上传文件大小不能超过2M');
            return false
        }

        return true;
    }
    private handleSuccess(res, index) {
        let path = res.Result[0];

        let img = new Image();
        img.onload = () => {
            this.formData.ImageAdvertisementList[index].ImgWidth = img.width;
            this.formData.ImageAdvertisementList[index].ImgHeight = img.height;
        }
        img.src = this.imgUrl + path;

        this.formData.ImageAdvertisementList[index].ImgUrl = path;

    }
    private handleChooseLink(index) {
        this.visible = true;
        this.selectedIndex = index;
        this.selectedData = {
            Id: this.formData.ImageAdvertisementList[index].LinkResourceId,
            type: this.formData.ImageAdvertisementList[index].LinkResourceType
        }
    }
    private chooseLinkChange(res) {
        if (res) {
            for (let item in res) {
                this.formData.ImageAdvertisementList[this.selectedIndex][item] = res[item];
            }
        }
        this.visible = false;
    }

    private async handleSave() {
        console.log(this.formData)

        const {
            ImageAdvertisementList
        } = this.formData;

        let i = -1;
        ImageAdvertisementList.map((item, index)=>{
            if (!item.ImgUrl && i === -1){
                i = index;
            }
        })
        if (i > -1){
            this.$message.error('请上传图片');
            let query = document.querySelector('#picture-item-'+i);
            query.scrollIntoView({block: "center"});
            return;
        }

        this.loading = true;
        try {
            const res: any = await bAppMallSave(this.formData);

            this.$message.success('操作成功');
            this.getData();

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

}
